import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getUrlQuery } from 'libs/utils';
import { ERoute } from 'enums/route.enum';
import { Modal } from 'antd';
import styled, { css } from 'styled-components';
import notificationMp3 from 'assets/audio/notification.mp3';
import menteeFileOff from 'assets/icons/ic-mentee-file-off.webp';
import menteeFileOn from 'assets/icons/ic-mentee-file-on.webp';
import menteeInfoOff from 'assets/icons/ic-mentee-info-off.webp';
import menteeInfoOn from 'assets/icons/ic-mentee-info-on.webp';
import audioOff from 'assets/icons/ic-mute.webp';
import videoOffIcon from 'assets/icons/ic_video_off_screen.webp';
import {
  MuteButton,
  UnmuteButton,
  StartVideoButton,
  StopVideoButton,
  EndButton,
  StartScreenShareButton,
  StopScreenShareButton,
} from '../../../components/atoms/CallButtons';
import Screen from '../../../components/templates/Screen';
import { StatefulDirectCall } from '../../../lib/sendbird-calls';
import { useSbCalls } from '../../../lib/sendbird-calls';
import * as mixins from '../../../styles/mixins';
import { isSafari } from '../../../utils';

const Wrapper = styled(Screen)`
  ${mixins.flexCenter};
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; // TODO: Temporary z-index because of menu dropdown coming upfront
  color: white;
  background-color: #000000;
`;

const PeerName = styled.div`
  position: absolute;
  bottom: 75px;
  left: 20px;
  font-size: 14px;
  font-weight: 700;
`;

type MediaViewSize = 'hidden' | 'small' | 'full';
const getVideoStyleFromSize = (size: MediaViewSize) => {
  switch (size) {
    case 'hidden':
      return css`
        opacity: 0;
        transition: all 0.5s;
        display: none;
      `;
    case 'small':
      return css`
        position: absolute;
        top: 16px;
        left: 16px;
        width: 235px;
        height: 132px;
        border: 1px solid #ffffff;
        border-radius: 8px;
      `;
    case 'full':
      return css`
        position: absolute;
        width: 100%;
        height: 100%;
        transition: all 1s;
      `;
    default:
      return '';
  }
};

const VideoViewDiv = styled.div<{ size: MediaViewSize }>`
  position: absolute;
  overflow: hidden;
  ${(props) => getVideoStyleFromSize(props.size)}
`;

const VideoView = styled.video<{ size: MediaViewSize; sharing: Boolean }>`
  width: 100%;
  padding: ${(props) => (props.size === 'small' ? '0px' : '10px')};
  height: ${(props) => (props.size === 'small' ? '100%' : 'calc(100% - 70px)')};
  position: absolute;
`;

const VideoOffView = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VideoOffIcon = styled.div<{ isConnected: Boolean }>`
  width: ${(props) => (props.isConnected ? '160px' : '30px')};
  height: ${(props) => (props.isConnected ? '160px' : '30px')};
  background-image: url(${videoOffIcon});
  background-size: ${(props) => (props.isConnected ? '160px' : '30px')};
  z-index: 9;
`;

const VideoFooter = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  align-items: center;
  width: 100vw;
  height: 70px;
  padding: 20px;
  background-color: #000000;
  position: absolute;
  bottom: 0;
`;

const NameBox = styled.div<{ pos: MediaViewSize }>`
  position: absolute;
  bottom: ${(props) => (props.pos === 'small' ? '5px' : '75px')};
  z-index: 5;
  left: 10px;
  font-weight: 700;
  font-size: 14px;
`;

const MuteIcon = styled.div<{ size: MediaViewSize }>`
  position: absolute;
  top: ${(props) => (props.size === 'small' ? '10px' : '40px')};
  right: ${(props) => (props.size === 'small' ? '10px' : '40px')};
  width: 30px;
  height: 30px;
  background-image: url(${audioOff});
  background-size: 30px;
  z-index: 10;
`;

const TimerContainer = styled.div`
  flex: 1;
`;

const BtnContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BtnContainer2 = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
`;

const MessageConatainer = styled.div`
  width: 33%;
`;

const MenteeInfoOffIcon = styled.div`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 50%;
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px;
  background-image: url(${menteeInfoOn});
`;

const MenteeInfoOnIcon = styled.div`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 50%;
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px;
  background-image: url(${menteeInfoOff});
`;

const MenteeFileOffIcon = styled.div`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 50%;
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px;
  background-image: url(${menteeFileOn});
`;

const MenteeFileOnIcon = styled.div`
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-color: transparent;
  border-radius: 50%;
  margin: 0 10px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 20px;
  background-image: url(${menteeFileOff});
`;

const notificationAlarm = new Audio(notificationMp3);

const IconBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
`;

const IconBox2 = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 70px;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
`;

interface CallViewProps {
  call: StatefulDirectCall;
  dial: () => void;
  showVideo: boolean;
  setShowVideo: (x: boolean) => void;
  onMicrophone: boolean;
  setOnMicrophone: (x: boolean) => void;
  onMenteeInfo: boolean;
  setOnMenteeInfo: (x: boolean) => void;
  onMenteeFile: boolean;
  setOnMenteeFile: (x: boolean) => void;
  backHandler: () => void;
}
const CallView: React.FC<CallViewProps> = ({
  call,
  dial,
  showVideo,
  setShowVideo,
  onMicrophone,
  setOnMicrophone,
  onMenteeInfo,
  setOnMenteeInfo,
  onMenteeFile,
  setOnMenteeFile,
  backHandler,
}) => {
  const history = useHistory();
  const location = useLocation();
  const [sharing, setSharing] = useState(false);
  const [catchVideoState, setCatchVideoState] = useState(showVideo);
  const [isClickedEnd, setIsClickedEnd] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  const { mentoring_id, my_id, partner_id } = getUrlQuery(location.search);

  const { clearCalls } = useSbCalls();
  const {
    callState,
    caller,
    localUser,
    remoteUser,
    isLocalAudioEnabled,
    isLocalVideoEnabled,
    endResult,
    isRemoteAudioEnabled,
    isRemoteVideoEnabled,
    localMediaView,
    remoteMediaView,
  } = call;

  useEffect(() => {
    return () => {
      clearCalls();
    };
  }, []);

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', backHandler);

    return () => {
      window.removeEventListener('popstate', backHandler);
      call.end();
    };
  }, []);

  useEffect(() => {
    (() => {
      window.addEventListener('beforeunload', call.end);
    })();

    return () => {
      window.addEventListener('beforeunload', call.end);
    };
  }, []);

  useEffect(() => {
    const customItemToAdd = { mentoring_call_id: mentoring_id };
    call.updateCustomItems(customItemToAdd, (result, error) => {
      // console.log('🍑 updateCustomItems result', result);
    });
  }, []);

  useEffect(() => {
    if (showVideo) {
      call.startVideo();
    } else {
      call.stopVideo();
    }
  }, [showVideo]);

  useEffect(() => {
    if (onMicrophone) {
      call.unmuteMicrophone();
    } else {
      call.muteMicrophone();
    }
  }, [onMicrophone]);

  const localMediaViewRef = useCallback((node) => {
    call.setLocalMediaView(node);
  }, []);

  const remoteMediaViewRef = useCallback((node) => {
    call.setRemoteMediaView(node);
  }, []);

  const exitSendbird = () => {
    call.end();
    setIsClickedEnd(true);
    history.push(`${ERoute.MentoringClassView.replace(':record_id', mentoring_id)}`);
    window.sessionStorage.removeItem('MenteeData');
    window.location.reload();
  };
  const errorModal = () => {
    Modal.error({
      title: '',
      content:
        '상대가 접속했지만 네트워크 오류로 인해 연결이 지연되고 있습니다. \n외부 링크를 통해 멘토링을 진행해주세요\n링크첨부',
      onOk: exitSendbird,
    });
  };

  const accept = useCallback(() => {
    call.accept({
      callOption: {
        localMediaView,
        remoteMediaView,
        audioEnabled: true,
        videoEnabled: showVideo,
      },
    });
  }, [localMediaView, remoteMediaView]);

  let localMediaViewSize: MediaViewSize;
  let remoteMediaViewSize: MediaViewSize;

  switch (callState) {
    case 'dialing':
      localMediaViewSize = 'full';
      remoteMediaViewSize = 'hidden';
      break;
    case 'ringing':
      localMediaViewSize = 'full';
      remoteMediaViewSize = 'hidden';
      accept();
      break;
    case 'connected':
      if (!isConnected) {
        notificationAlarm.play();
        setIsConnected(true);
      }
      localMediaViewSize = 'small';
      remoteMediaViewSize = 'full';
      break;
    case 'reconnecting':
      call.end();
      clearCalls();
      dial();
      localMediaViewSize = 'small';
      remoteMediaViewSize = 'full';
      break;
    case 'ended':
      setOnMenteeFile(false);
      setOnMenteeInfo(false);
      clearCalls();
      if (endResult === 'no_answer') {
        dial();
      }

      if (endResult === 'timed_out') {
        // errorModal();
      }

      if (endResult === 'completed') {
        if (!isClickedEnd) {
          dial();
        }
      }
      localMediaViewSize = 'hidden';
      remoteMediaViewSize = 'hidden';
      break;
    default:
      localMediaViewSize = 'hidden';
      remoteMediaViewSize = 'hidden';
  }

  const is = useCallback((...states) => states.some((state) => state === callState), [callState]);
  const isNot = useCallback((...states) => !states.some((state) => state === callState), [callState]);

  const isMentorStorage =
    window.sessionStorage.getItem('MenteeData') !== undefined &&
    window.sessionStorage.getItem('MenteeData') !== 'none';

  return (
    <Wrapper>
      {!isLocalAudioEnabled && callState === 'dialing' && <MuteIcon size={localMediaViewSize} />}
      {!isRemoteAudioEnabled && callState === 'connected' && <MuteIcon size={remoteMediaViewSize} />}
      {(callState === 'dialing' && isLocalVideoEnabled) || (callState !== 'dialing' && call.isVideoCall) ? (
        <>
          <VideoViewDiv size={remoteMediaViewSize}>
            <PeerName>{remoteUser.nickname || remoteUser.userId}</PeerName>
            <VideoView
              ref={remoteMediaViewRef}
              size={remoteMediaViewSize}
              playsInline
              autoPlay
              sharing={sharing}
              muted={false}
              controls={isSafari()}
              disablePictureInPicture={true}
            />
            {!isRemoteVideoEnabled && (
              <VideoOffView>
                <VideoOffIcon isConnected={true} />
              </VideoOffView>
            )}
          </VideoViewDiv>
          <VideoViewDiv size={localMediaViewSize}>
            {!isLocalAudioEnabled && callState === 'connected' && <MuteIcon size={localMediaViewSize} />}
            <NameBox pos={localMediaViewSize}>나</NameBox>
            <VideoView
              ref={localMediaViewRef}
              playsInline
              autoPlay
              muted
              size={localMediaViewSize}
              sharing={sharing}
              style={{ backgroundColor: 'var(--white)' }}
              disablePictureInPicture={true}
            />
            {!isLocalVideoEnabled && (
              <VideoOffView>
                <VideoOffIcon isConnected={callState !== 'connected'} />
              </VideoOffView>
            )}
          </VideoViewDiv>
        </>
      ) : (
        <>
          <VideoOffView>
            <VideoOffIcon isConnected={callState !== 'connected'} />
          </VideoOffView>
          <audio ref={localMediaViewRef} playsInline autoPlay muted />
          <audio ref={remoteMediaViewRef} playsInline autoPlay muted={false} controls={isSafari()} />
        </>
      )}
      {isNot('ended') && (
        <VideoFooter>
          <TimerContainer>{is('connected') && <Timer />}</TimerContainer>

          <BtnContainer>
            {isNot('ended') && [
              isLocalAudioEnabled ? (
                <MuteButton
                  key='mute-audio'
                  onClick={() => {
                    setOnMicrophone(false);
                  }}
                />
              ) : (
                <UnmuteButton
                  key='unmute-audio'
                  onClick={() => {
                    setOnMicrophone(true);
                  }}
                />
              ),
              (isLocalVideoEnabled && !sharing) || (catchVideoState && sharing) ? (
                <StartVideoButton
                  key='stop-video'
                  onClick={() => {
                    if (sharing) {
                      setCatchVideoState(false);
                    } else {
                      setShowVideo(false);
                    }
                  }}
                />
              ) : (
                <StopVideoButton
                  key='start-video'
                  onClick={() => {
                    if (sharing) {
                      setCatchVideoState(true);
                    } else {
                      setShowVideo(true);
                    }
                  }}
                />
              ),
              (is('connected') || is('reconnected')) && !sharing && (
                <StartScreenShareButton
                  onClick={async () => {
                    try {
                      await call.startScreenShare();
                      setSharing(true);
                      setCatchVideoState(isLocalVideoEnabled);
                      setShowVideo(true);
                    } catch (e) {
                      // add your process for start screen share fail.
                    }
                  }}
                />
              ),
              (is('connected') || is('reconnected')) && sharing && (
                <StopScreenShareButton
                  onClick={() => {
                    if (sharing) {
                      call.stopScreenShare();
                      setSharing(false);
                      setShowVideo(catchVideoState);
                    }
                  }}
                />
              ),
            ]}
            {isNot('ended') && (
              <EndButton
                onClick={() => {
                  call.end();
                  setIsClickedEnd(true);
                  history.push(`${ERoute.MentoringClassView.replace(':record_id', mentoring_id)}`);
                  window.sessionStorage.removeItem('MenteeData');
                  window.location.reload();
                }}
              />
            )}
          </BtnContainer>
          {isMentorStorage ? (
            <BtnContainer2>
              {onMenteeInfo ? (
                <IconBox>
                  <MenteeInfoOnIcon
                    onClick={() => (onMenteeInfo ? setOnMenteeInfo(false) : setOnMenteeInfo(true))}
                  />
                  <div>요청사항</div>
                </IconBox>
              ) : (
                <IconBox>
                  <MenteeInfoOffIcon
                    onClick={() => (onMenteeInfo ? setOnMenteeInfo(false) : setOnMenteeInfo(true))}
                  />
                  <div>요청사항</div>
                </IconBox>
              )}
              {onMenteeFile ? (
                <IconBox2>
                  <MenteeFileOnIcon onClick={() => setOnMenteeFile(false)} />
                  <div>첨부파일</div>
                </IconBox2>
              ) : (
                <IconBox2>
                  <MenteeFileOffIcon onClick={() => setOnMenteeFile(true)} />
                  <div>첨부파일</div>
                </IconBox2>
              )}
            </BtnContainer2>
          ) : (
            <BtnContainer />
          )}
        </VideoFooter>
      )}
      <MessageConatainer>
        {is('connected') && <PeerName>{remoteUser.nickname || remoteUser.userId}</PeerName>}
      </MessageConatainer>
    </Wrapper>
  );
};

export default CallView;

const Timer = () => {
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds(seconds + 1);

      if (seconds === 59) {
        setMinutes(minutes + 1);
        setSeconds(0);
      }
    }, 1000);
    return () => clearInterval(countdown);
  }, [minutes, seconds]);

  return (
    <div>
      {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </div>
  );
};
